import * as prismic from "@prismicio/client";

interface GetPrismicDocumentParams {
    repoUrl: string;
    documentType: string;
}

export const getPrismicDocument = async ({
    repoUrl,
    documentType,
}: GetPrismicDocumentParams): Promise<string | null> => {
    try {
        const hostname = new URL(repoUrl).hostname;
        const repoName = hostname.split(".")[0];

        const endpoint = prismic.getRepositoryEndpoint(repoName);
        const client = prismic.createClient(endpoint);

        const documents = await client.getByType(documentType);

        if (!documents?.results?.length) {
            console.warn(`No "${documentType}" documents found`);
            return null;
        }

        return documents?.results?.[0].id;
    } catch (error) {
        console.error(`Error fetching "${documentType}" from Prismic:`, error);
        return null;
    }
};
